<template>
  <div class="w-full" data-testid="welcome-popup">
    <!-- Title Section -->
    <div class="mb-5 self-stretch relative w-full flex items-center justify-center gap-2">
      <header class="absolute left-0 top-1/2 -translate-y-1/2" v-show="backButtonShown">
        <a href="javascript:;" @click="back" data-testid="back-button">
          <img src="@/assets/icons/arrow-left.svg" class="w-[25px]" />
        </a>
      </header>
        <div class="self-stretch flex flex-col text-center items-center gap-1">
            <div class="self-stretch text-center text-white text-2xl font-bold font-['Inter'] leading-[30px]" data-testid="join-session-title">
            {{ $t('join_session') !== 'join_session' ? $t('join_session') : 'Join a Session' }}
            </div>
        </div>
    </div>
    
    <div v-if="selectorExpanded">
      <language-picker v-show="selectorExpanded" :initial="profile.language" :close-on-select="false" :open="openLanguageSelector" @back="onLanguageBack" @globalback="saveProfile" @select="selectLanguage" data-testid="language-picker"></language-picker>
    </div>
    <form v-else action="#" method="POST" @submit.prevent="saveProfile" data-testid="welcome-form">
        <div class="mb-3 max-[800px]:mb-[18px] border-t border-[rgba(57,57,57,0.5)] pt-3">
            <label class="block text-white/90 text-base leading-[1.18rem] mb-2" for="#profile_name" data-testid="display-name-label">{{ $t('display_name') !== 'display_name' ? $t('display_name') : 'Display name' }}</label>
            <input type="text" required name="name" v-model="profile.name" class="border-2 border-[#292F36] rounded-[10px] bg-transparent text-white font-normal text-base leading-[1.18rem] h-[44px] w-full px-[10px] outline-none focus:border-[#6CBFFF]" placeholder="" data-testid="guest-name">
        </div>
        
        <div class="mb-6 max-[800px]:mb-[18px]">
         <div class="block text-white/90 text-base leading-[1.18rem] mb-2" data-testid="language-label">{{ $t('profile_language') }}</div>
          <div class=" flex items-center justify-between border-2 border-[#292F36] rounded-[10px] bg-transparent text-white font-normal text-base leading-[1.18rem] h-[44px] w-full px-[10px] outline-none focus:border-[#6CBFFF] cursor-pointer" @click="expandSelector" data-testid="language-selector">
            <div class="flex items-center">
              <span class="w-[20px] h-[20px] flex rounded-full"><img class="rounded-full w-[20px] h-[20px]" :src="'/data/flags/' + profile.language + '.png'" data-testid="language-flag"/></span>
              <span class="font-inter font-normal text-[1rem] leading-[1.18rem] text-white ml-[10px]" data-testid="language-name">{{ selectedLangName }}</span>
            </div>
            <img src="@/assets/icons/chevron-down-white.svg" class="w-[16px] h-[16px]" data-testid="language-dropdown-icon" />
          </div>
        </div>
        <div class="w-full mb-3">
          <button
              type="submit"
              name="profile_submit"
              id="profile_submit"
              class="w-full h-[40px] px-[30px] bg-[#6CBFFF] hover:bg-opacity-30 rounded-xl shadow-[0px_5.01333px_5.01333px_rgba(0,0,0,0.25)] inline-flex justify-center items-center gap-2 overflow-hidden transition duration-160 cursor-pointer"
              value="Save"
              data-testid="join-now-button"
              > 
              <div class="text-black text-base font-medium font-['Inter'] leading-normal" data-testid="join-now-text">
              {{ $t('join_now') !== 'join_now' ? $t('join_now') : 'Join now' }}
              </div>
          </button>
        </div>

    </form>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import LanguagePicker from '../session/LanguagePicker.vue';

const ADJECTIVES = [
  "Quick","Bright","Swift","Clear","Wise","Bold","Keen","Sharp","Happy","Warm",
  "Kind","Noble","Gentle","Clever","Witty","Smart","Calm","Steady","Silent","Quiet",
  "Serene","Cool","Fresh","Lively","Brave","Glad","Merry","Eager","Ready","Active"
];

const NOUNS = [
  "Panda","Fox","Bear","Wolf","Deer","Swan","Owl","Hawk","Otter","Seal",
  "Lynx","Hare","Robin","Finch","Wren","Dove","Cloud","Star","Wave","River",
  "Moon","Sun","Rain","Wind","Storm","Sky"
];

function randInt(min, maxInclusive) {
  return Math.floor(Math.random() * (maxInclusive - min + 1)) + min;
}

function pick(arr) {
  return arr[randInt(0, arr.length - 1)];
}

function generateGuestNameWeb() {
  const adj = pick(ADJECTIVES);
  const noun = pick(NOUNS);
  const num = randInt(0, 99);
  return `${adj}${noun}_w${num}`;
}

function isDefaultGuestName(name) {
  if (!name) return true;
  const n = String(name).trim();
  if (n === '' || n === 'Guest') return true;
  return /^Guest\s+\d+$/i.test(n);
}


export default {
  name: 'ProfilePopup',
  props: {
    participant: {
      type: Object,
      required: true
    },
    participants_number: {
      type: Number,
      required: false,
      default: 0
    },
    openLanguageSelector: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      profile: this.participant,
      backButtonShown: true,
      selectorExpanded: false,
    }
  },
  components: {
    LanguagePicker
  },
  created() {
    if (isDefaultGuestName(this.profile?.name)) {
      this.profile.name = generateGuestNameWeb();
    }
  },


  methods: {
    saveProfile() {
      if (this.profile.name.trim() === '') {
        return;
      }
      if (this.authorized) {
        this.$store.dispatch("auth/update", this.profile);
      }

      this.$emit("saved", {profile: this.profile});
      this.selfClose();
    },
    selectLanguage(langCode) {
      this.backButtonShown = true;
      this.profile.language = langCode;
      if (this.openLanguageSelector) {
        this.saveProfile();
      }
    },
    expandSelector() {
      this.selectorExpanded = true;
    },
    back() {
      if (this.selectorExpanded){
        this.selectorExpanded = false;
      }
      else{
        this.selfClose();
        this.$router.push("/");
      }
    },
    onLanguageBack() {
      this.backButtonShown = true;
    },
    selfClose() {
      this.$emitter.emit('modalClose');
    },
  },
  computed: {
     ...mapState('auth', ['token', 'authorized']),
      ...mapState('nonpersist', ['user']),
      ...mapState('lang', ['languages']),
      selectedLangName() {
        if (!this.languages || !this.profile.language) return this.profile.language;
        const langObj = this.languages.find(lang => lang.code === this.profile.language)
          || this.languages.flatMap(lang => lang.dialects || []).find(d => d.code === this.profile.language);
        return langObj ? (langObj.native_name || langObj.name) : this.profile.language;
      }
  },
}
</script>

<style lang="scss" scoped>
//prevent the bowser from changing the background when autofilling
  input:-webkit-autofill,
  textarea:-webkit-autofill,
  select:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
    -webkit-text-fill-color: #fff !important;
    transition: background-color 5000s ease-in-out 0s;
  }
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  }
</style>
